import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';

// Set to false if the 30-day guarantee is NOT confirmed by the final commercial policy.
const SHOW_GUARANTEE_MICROCOPY = true;
const microcopy = ['Direkt tillgång', 'Utskriftsklart', 'Engångsbetalning', ...(SHOW_GUARANTEE_MICROCOPY ? ['30 dagars garanti'] : [])];
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-20 sm:px-8" data-id="element-79" data-mp="1jclja7depdpu">
      <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center" data-id="element-80" data-mp="1jb230grr32o2">
        <Reveal data-id="element-81" data-mp="1eds50cqapiom">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-cream sm:text-4xl" data-id="element-82" data-mp="1ec7ldi5irk5j">
            Redo att ta med{' '}
            <span className="font-serif italic font-normal text-gold" data-id="element-83" data-mp="1o3lftbim5trt">innebandy</span>{' '}
            till varje lektion och träning?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-84" data-mp="2219z4ex18sur">
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-cream/70" data-id="element-85" data-mp="1x51onets5ntx">
            Spara din förberedelsetid och undervisa varje pass med en tydlig plan, roliga
            övningar och verklig trygghet.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="w-full max-w-md" data-id="element-86" data-mp="s6s0y5kg81e1">
          <div className="mt-10 w-full" data-id="element-87" data-mp="x2qu06gq27ks">
            <CtaButton data-id="element-88" data-mp="x5v8pxrtclpp" />
          </div>
        </Reveal>

        <Reveal delay={0.18} data-id="element-89" data-mp="123wnw7m4c0vw">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-cream/70 sm:text-sm" data-id="element-90" data-mp="1246ik8i3yw7x">
            {microcopy.map((item, index) => <React.Fragment key={item} data-id="element-91" data-mp="1b1yvx749rtso" data-mpi={index}>
                {index > 0 && <li aria-hidden="true" className="text-cream/30" data-id="element-92" data-mp="1fvb8ujzl6c5l">
                    ·
                  </li>}
                <li className="whitespace-nowrap" data-id="element-93" data-mp="1ksl5okpb1q3g">{item}</li>
              </React.Fragment>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}